<div class="headerimage" [@divState]="state">
	<h1 class="imagetext">We Make IT Happen!</h1>
</div>
